module.exports = __webpack_public_path__ + "6b10b130a21dcd26ff3a978ad2b45f67.svg";